import { z } from "zod";
export const BudgetCategorySchema = z.enum([
    "venue",
    "catering",
    "photography",
    "music",
    "flowers",
    "attire",
    "transport",
    "beauty",
    "invitations",
    "rings",
    "cake",
    "accommodation",
    "other",
]);
export const BudgetItemSchema = z.object({
    id: z.string(),
    category: BudgetCategorySchema,
    supplierName: z.string().nullable().optional(),
    vendorId: z.string().nullable().optional(),
    estimatedCost: z.number().nonnegative(),
    actualCost: z.number().nonnegative(),
    depositPaid: z.number().nonnegative().default(0),
    dueDate: z.string().datetime().nullable().optional(),
    isPaid: z.boolean().default(false),
    notes: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
